<template>
    <div class="chat_workspace_wrp">
        <div id="sidepanel">
            <div id="search">
                <div class="row align-items-center">
                    <div class="col-auto pr-0">
                        <template v-if="selfUserInfo">
                            <template v-if="selfUserInfo.pro_payment || selfUserInfo.auto_payment">
                                <button class="btn btn-primary team_group_create_btn"
                                    @click="createGroupPopupEnabledFun">Teams</button>
                            </template>
                            <template v-else>
                                <button class="btn gray_out_global_btn" style="font-size: 17px !important;
                                font-family: AceSansDemo;
                                border-radius: 3px !important;
                                padding: 7px 10px !important;
                                min-width: 80px !important;
                                line-height: 1 !important;
                                letter-spacing: 1px;" 
                                @click="accessFeaturesOfPackagemethod">Teams</button>
                            </template>
                        </template>
                    </div>
                    <div class="col text-right chat_menuburger_wrp pl-2">
                        <template v-if="!isMobile">
                            <button class="btn btn-default mr-2"
                                @click="individualActivityTrackerOpenMethod">Tracker</button>
                            <router-link :to="{ name: 'saChatRequestList' }" class="btn btn-default mr-2">Requests
                                <template v-if="connectionRequestCount">
                                    <i v-if="connectionRequestCount.connectionRequestCount > 0"
                                        class="badge badge-dark connectionRequestCountWrp">{{
                                            connectionRequestCount.connectionRequestCount }}</i>
                                </template>
                            </router-link>
                        </template>
                        <template v-else>
                            <button class="btn btn-default mr-2" @click="mblToolbarEnabledMethod">Tools</button>
                        </template>
                        <selfUserStatus></selfUserStatus>
                        <span class="chat_menuburger">
                            <span></span>
                            <span></span>
                            <span></span>
                        </span>
                        <ul class="chat_menu_list">
                            <li>
                                <router-link to="/chat/user/block/list/">Block List</router-link>
                            </li>
                            <li v-if="isMobile">
                                <router-link :to="{ name: 'saChatRequestList' }">Requests
                                    <template v-if="connectionRequestCount">
                                        <i v-if="connectionRequestCount.connectionRequestCount > 0"
                                            class="badge badge-dark connectionRequestCountWrp">{{
                                                connectionRequestCount.connectionRequestCount }}</i>
                                    </template>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="user_search_for_new_chat" :class="{ 'search_enabled': isSearchEnabled }"
                v-click-outside="outsideClickOfSearchFieldMethod" v-if="!welcomeBlurbState">
                <div class="search_for_new_chat_inner">
                    <span class="back">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                            @click="searchBarForChatClosedFun">
                            <path fill="#ffd400" d="M12 4l1.4 1.4L7.8 11H20v2H7.8l5.6 5.6L12 20l-8-8 8-8z"></path>
                        </svg>
                    </span>
                    <span class="search">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                            <path fill="#ffffff"
                                d="M15.009 13.805h-.636l-.22-.219a5.184 5.184 0 0 0 1.256-3.386 5.207 5.207 0 1 0-5.207 5.208 5.183 5.183 0 0 0 3.385-1.255l.221.22v.635l4.004 3.999 1.194-1.195-3.997-4.007zm-4.808 0a3.605 3.605 0 1 1 0-7.21 3.605 3.605 0 0 1 0 7.21z">
                            </path>
                        </svg>
                    </span>
                    <input class="form-control" v-model="search_term" placeholder="Search or start new chat"
                        @keyup="debouncedSearch" @focus="handleSearchbarFocus">
                    <span class="x-alt" @click="searchBarForChatClosedFun"
                        :class="{ 'search_disabled_btn': userSearchListTabs }">
                        <svg height="15px" viewBox="0 0 329.26933 329" width="15px" xmlns="http://www.w3.org/2000/svg">
                            <g fill="#f44336">
                                <path
                                    d="m21.339844 329.398438c-5.460938 0-10.925782-2.089844-15.082032-6.25-8.34375-8.339844-8.34375-21.824219 0-30.164063l286.589844-286.59375c8.339844-8.339844 21.824219-8.339844 30.164063 0 8.34375 8.339844 8.34375 21.824219 0 30.164063l-286.589844 286.59375c-4.183594 4.179687-9.621094 6.25-15.082031 6.25zm0 0" />
                                <path
                                    d="m307.929688 329.398438c-5.460938 0-10.921876-2.089844-15.082032-6.25l-286.589844-286.59375c-8.34375-8.339844-8.34375-21.824219 0-30.164063 8.339844-8.339844 21.820313-8.339844 30.164063 0l286.589844 286.59375c8.34375 8.339844 8.34375 21.824219 0 30.164063-4.160157 4.179687-9.621094 6.25-15.082031 6.25zm0 0" />
                            </g>
                        </svg>
                    </span>
                </div>
            </div>
            <div id="contacts_list" ref="chatList" @scroll="handleScroll">
                <div class="collsaped_chatlist_menu">
                    <div class="row align-items-end">
                        <div class="col-auto pr-0">
                            <template v-if="selfUserInfo">
                                <template v-if="selfUserInfo.pro_payment || selfUserInfo.auto_payment">
                                    <button class="btn btn-primary team_group_create_btn"
                                        @click="createGroupPopupEnabledFun">Teams</button>
                                </template>
                                <template v-else>
                                    <button class="btn gray_out_global_btn" style="font-size: 17px !important;
                                    font-family: AceSansDemo;
                                    border-radius: 3px !important;
                                    padding: 7px 10px !important;
                                    min-width: 80px !important;
                                    line-height: 1 !important;
                                    letter-spacing: 1px;" @click="accessFeaturesOfPackagemethod">Teams</button>
                                </template>
                            </template>
                        </div>
                        <div class="col text-right chat_menuburger_wrp" :class="menuBurgerState ? 'active' : ''"
                            v-click-outside="menuBurgerClosedMethod">
                            <span class="chat_menuburger">
                                <i class="fa fa-bars" aria-hidden="true" @click="menuBurgerMethod"></i>
                            </span>
                            <ul class="chat_menu_list">
                                <li>
                                    <router-link to="/chat/user/block/list/">Block List</router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'saChatRequestList' }">Requests
                                        <template v-if="connectionRequestCount">
                                            <i v-if="connectionRequestCount.connectionRequestCount > 0"
                                                class="badge badge-dark connectionRequestCountWrp">{{
                                                    connectionRequestCount.connectionRequestCount }}</i>
                                        </template>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- Search Room List -->
                <div v-if="userSearchListTabs" class="user_search_list_for_chat">
                    <template v-if="chatSearchItemListData">
                        <ul v-if="chatSearchItemList.length > 0">
                            <li class="contact chat_user_listed" v-for="(item, index) in chatSearchItemList"
                                :id="'userChatListingId' + item.chat_room" :key="index">
                                <template v-if="item.is_group_chat">
                                    <div class="wrap chats_tab_name" @click="selectChatRoomForMessageMethod(item)"
                                        :title="item.name">
                                        <span class="user_prfl_status">
                                            <img :src="item.group_image" v-if="item.group_image" alt="">
                                            <img src="@/assets/images/user_circle_avtar.png" v-else alt="" />
                                        </span>
                                        <div class="meta">
                                            <p class="name">
                                                {{ item.name }}
                                                <span class="unread_msg" v-if="item.unread_count">{{ item.unread_count
                                                }}</span>
                                            </p>
                                            <template v-if="typingUserInfoState">
                                                <span class="typing_info_text"
                                                    v-if="chatItemInfo.chat_room == typingUserInfoState.ChatRoomId">
                                                    <template v-if="!collapseActvToggleState">{{
                                                        typingUserInfoState.typing_user.first_name }}
                                                        is</template>
                                                    typing...</span>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="wrap chats_tab_name">
                                        <span class="user_prfl_status">
                                            <img :src="item.user.profile.thumbnail" v-if="item.user.profile.thumbnail"
                                                class="chat_user_photo">
                                            <img src="@/assets/images/user_circle_avtar.png" alt="" v-else />
                                            <i class="online-status" v-bind:class="{ online: item.user.is_online }"></i>
                                        </span>
                                        <div class="meta" @click="selectChatRoomForMessageMethod(item)">
                                            <p class="name" v-if="item.user.first_name">
                                                {{ item.user.first_name }} {{ item.user.last_name }}</p>
                                            <p class="name" v-else>Guest Name</p>
                                        </div>
                                    </div>
                                    <template v-if="item.user.is_online">
                                        <button class="btn btn-primary message_request_btn video_calling_btn_wrp"
                                            @click="videoCallRequestFun(item.user.id, item.chat_room)"
                                            :id="'videocallbtn' + item.user.id">
                                            <span class="call_txt">
                                                <svg xmlns="http://www.w3.org/2000/svg"
                                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                                    xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="39"
                                                    height="39" x="0" y="0" viewBox="0 0 452 452"
                                                    style="enable-background:new 0 0 48 48;" xml:space="preserve">
                                                    <g>
                                                        <path xmlns="http://www.w3.org/2000/svg"
                                                            d="m452 25.121094v227.820312l-121.878906-66.550781h-1.210938v-94.71875h1.210938zm0 0"
                                                            fill="#0aefea" data-original="#0aefea" />
                                                        <path xmlns="http://www.w3.org/2000/svg"
                                                            d="m328.910156 186.390625v51.03125c0 22.089844-17.910156 40-40 40h-248.910156c-22.089844 0-40-17.910156-40-40v-197.421875c0-22.089844 17.910156-40 40-40h248.910156c22.089844 0 40 17.910156 40 40zm0 0"
                                                            fill="#0aefea" data-original="#00efd1" />
                                                    </g>
                                                </svg>
                                            </span>
                                            <span class="calling_txt">Calling</span>
                                        </button>
                                    </template>
                                    <template v-else>
                                        <button
                                            class="btn btn-primary message_request_btn disabled_btn_global video_calling_btn_wrp"
                                            disabled>
                                            <span class="call_txt">
                                                <svg xmlns="http://www.w3.org/2000/svg"
                                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                                    xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="39"
                                                    height="39" x="0" y="0" viewBox="0 0 452 452"
                                                    style="enable-background:new 0 0 48 48;" xml:space="preserve">
                                                    <g>
                                                        <path xmlns="http://www.w3.org/2000/svg"
                                                            d="m452 25.121094v227.820312l-121.878906-66.550781h-1.210938v-94.71875h1.210938zm0 0"
                                                            fill="#4a6b6b" data-original="#4a6b6b" />
                                                        <path xmlns="http://www.w3.org/2000/svg"
                                                            d="m328.910156 186.390625v51.03125c0 22.089844-17.910156 40-40 40h-248.910156c-22.089844 0-40-17.910156-40-40v-197.421875c0-22.089844 17.910156-40 40-40h248.910156c22.089844 0 40 17.910156 40 40zm0 0"
                                                            fill="#4a6b6b" data-original="#4a6b6b" />
                                                    </g>
                                                </svg>
                                            </span>
                                        </button>
                                    </template>
                                    <button
                                        class="btn btn-primary message_request_btn member_chat_start video_call_request"
                                        @click="selectChatRoomForMessageMethod(item)">
                                        <svg xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                            xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="24" height="24"
                                            x="0" y="0" viewBox="0 0 373.232 373.232"
                                            style="enable-background:new 0 0 512 512" xml:space="preserve">
                                            <g>
                                                <g xmlns="http://www.w3.org/2000/svg">
                                                    <g>
                                                        <path
                                                            d="M187.466,0c-0.1,0-0.3,0-0.6,0c-101.2,0-183.5,82.3-183.5,183.5c0,41.3,14.1,81.4,39.9,113.7l-26.7,62.1    c-2.2,5.1,0.2,11,5.2,13.1c1.8,0.8,3.8,1,5.7,0.7l97.9-17.2c19.6,7.1,40.2,10.7,61,10.6c101.2,0,183.5-82.3,183.5-183.5    C370.066,82.1,288.366,0.1,187.466,0z M124.666,146.6h54c5.5,0,10,4.5,10,10s-4.5,10-10,10h-54c-5.5,0-10-4.5-10-10    S119.166,146.6,124.666,146.6z M248.666,216.6h-124c-5.5,0-10-4.5-10-10s4.5-10,10-10h124c5.5,0,10,4.5,10,10    S254.166,216.6,248.666,216.6z"
                                                            fill="#ffc107" data-original="#000000" />
                                                    </g>
                                                </g>
                                                <g xmlns="http://www.w3.org/2000/svg">
                                                </g>
                                                <g xmlns="http://www.w3.org/2000/svg">
                                                </g>
                                                <g xmlns="http://www.w3.org/2000/svg">
                                                </g>
                                                <g xmlns="http://www.w3.org/2000/svg">
                                                </g>
                                                <g xmlns="http://www.w3.org/2000/svg">
                                                </g>
                                                <g xmlns="http://www.w3.org/2000/svg">
                                                </g>
                                                <g xmlns="http://www.w3.org/2000/svg">
                                                </g>
                                                <g xmlns="http://www.w3.org/2000/svg">
                                                </g>
                                                <g xmlns="http://www.w3.org/2000/svg">
                                                </g>
                                                <g xmlns="http://www.w3.org/2000/svg">
                                                </g>
                                                <g xmlns="http://www.w3.org/2000/svg">
                                                </g>
                                                <g xmlns="http://www.w3.org/2000/svg">
                                                </g>
                                                <g xmlns="http://www.w3.org/2000/svg">
                                                </g>
                                                <g xmlns="http://www.w3.org/2000/svg">
                                                </g>
                                                <g xmlns="http://www.w3.org/2000/svg">
                                                </g>
                                            </g>
                                        </svg>
                                    </button>
                                </template>
                            </li>
                        </ul>
                        <div class="no_contact_found_txt" v-else>No chats, contacts</div>
                    </template>
                    <div class="no_contact_found_txt" v-else>{{ searchingContactText }}</div>
                </div>
                <!-- Search Room List -->
                <!-- Connected Room List -->
                <template v-else>
                    <div class="user_list_for_chat" v-if="fullChatData">
                        <ul>
                            <template v-if="pinnedChatRoomList && pinnedChatRoomList.length > 0">
                                <li class="contact chat_user_listed" v-for="(chatItemInfo, index) in pinnedChatRoomList"
                                    :key="index" :id="'userChatListingId' + chatItemInfo.chat_room"
                                    :style="{ 'order': 0 }"
                                    :class="chatItemInfo.chat_room == (chatRoomInfo && chatRoomInfo.chat_room) ? 'active' : ''">
                                    <template v-if="chatItemInfo.is_group_chat">
                                        <div class="wrap chats_tab_name"
                                            @click="selectChatRoomForMessageMethod(chatItemInfo)"
                                            :title="chatItemInfo.name">
                                            <span class="user_prfl_status">
                                                <img :src="chatItemInfo.group_image" v-if="chatItemInfo.group_image"
                                                    alt="">
                                                <img src="@/assets/images/user_circle_avtar.png" v-else alt="" />
                                            </span>
                                            <div class="meta">
                                                <p class="name">
                                                    {{ chatItemInfo.name }}
                                                    <span class="unread_msg" v-if="chatItemInfo.unread_count">{{
                                                        chatItemInfo.unread_count }}</span>
                                                </p>
                                                <template v-if="typingUserInfoState">
                                                    <span class="typing_info_text"
                                                        v-if="chatItemInfo.chat_room == typingUserInfoState.ChatRoomId">
                                                        <template v-if="!collapseActvToggleState">{{
                                                            typingUserInfoState.typing_user.first_name }}
                                                            is</template>
                                                        typing...</span>
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="wrap chats_tab_name"
                                            @click="selectChatRoomForMessageMethod(chatItemInfo)">
                                            <span class="user_prfl_status">
                                                <img :src="chatItemInfo.user.profile.thumbnail"
                                                    v-if="chatItemInfo.user.profile.thumbnail" class="chat_user_photo">
                                                <img src="@/assets/images/user_circle_avtar.png" alt="" v-else />
                                                <i class="online-status"
                                                    v-bind:class="{ online: chatItemInfo.user.is_online }"></i>
                                            </span>
                                            <div class="meta">
                                                <p class="name" v-if="chatItemInfo.user.first_name">
                                                    {{ chatItemInfo.user.first_name }}
                                                    {{ chatItemInfo.user.last_name }}<span class="unread_msg"
                                                        v-if="chatItemInfo.unread_count">{{ chatItemInfo.unread_count
                                                        }}</span>
                                                </p>
                                                <p class="name" v-else>Guest Name <span class="unread_msg"
                                                        v-if="chatItemInfo.unread_count">{{ chatItemInfo.unread_count
                                                        }}</span>
                                                </p>
                                                <template v-if="typingUserInfoState">
                                                    <span class="typing_info_text"
                                                        v-if="chatItemInfo.chat_room == typingUserInfoState.ChatRoomId">
                                                        <template v-if="!collapseActvToggleState">typing</template>
                                                        ...</span>
                                                </template>
                                            </div>
                                        </div>
                                        <template
                                            v-if="chatItemInfo.user.is_online && chatItemInfo.user.browser_online">
                                            <button class="btn btn-primary message_request_btn video_call_request"
                                                @click="videoCallRequestFun(chatItemInfo.user.id, chatItemInfo.chat_room)"
                                                :id="'videocallbtn' + chatItemInfo.user.id">
                                                <span class="call_txt">
                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                                        xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="38"
                                                        height="38" x="0" y="0" viewBox="0 0 452 452"
                                                        style="enable-background:new 0 0 48 48;" xml:space="preserve">
                                                        <g>
                                                            <path xmlns="http://www.w3.org/2000/svg"
                                                                d="m452 25.121094v227.820312l-121.878906-66.550781h-1.210938v-94.71875h1.210938zm0 0"
                                                                fill="#0aefea" data-original="#0aefea" />
                                                            <path xmlns="http://www.w3.org/2000/svg"
                                                                d="m328.910156 186.390625v51.03125c0 22.089844-17.910156 40-40 40h-248.910156c-22.089844 0-40-17.910156-40-40v-197.421875c0-22.089844 17.910156-40 40-40h248.910156c22.089844 0 40 17.910156 40 40zm0 0"
                                                                fill="#0aefea" data-original="#00efd1" />
                                                        </g>
                                                    </svg>
                                                </span>
                                                <span class="calling_txt">Calling</span>
                                            </button>
                                        </template>
                                        <template v-else>
                                            <button class="btn btn-primary message_request_btn video_call_request"
                                                disabled="disabled">
                                                <span class="call_txt">
                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                                        xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="38"
                                                        height="38" x="0" y="0" viewBox="0 0 452 452"
                                                        style="enable-background:new 0 0 48 48;" xml:space="preserve">
                                                        <g>
                                                            <path xmlns="http://www.w3.org/2000/svg"
                                                                d="m452 25.121094v227.820312l-121.878906-66.550781h-1.210938v-94.71875h1.210938zm0 0"
                                                                fill="#0aefea" data-original="#0aefea" />
                                                            <path xmlns="http://www.w3.org/2000/svg"
                                                                d="m328.910156 186.390625v51.03125c0 22.089844-17.910156 40-40 40h-248.910156c-22.089844 0-40-17.910156-40-40v-197.421875c0-22.089844 17.910156-40 40-40h248.910156c22.089844 0 40 17.910156 40 40zm0 0"
                                                                fill="#0aefea" data-original="#00efd1" />
                                                        </g>
                                                    </svg>
                                                </span>
                                            </button>
                                        </template>
                                    </template>
                                </li>
                            </template>
                            <template v-if="fullChatRoomListResult && fullChatRoomListResult.length > 0">
                                <li class="contact chat_user_listed"
                                    v-for="(chatItemInfo, index) in fullChatRoomListResult"
                                    :key="chatItemInfo.chat_room" :id="'userChatListingId' + chatItemInfo.chat_room"
                                    :style="{ 'order': index + 1 }"
                                    :class="chatItemInfo.chat_room == (chatRoomInfo && chatRoomInfo.chat_room) ? 'active' : ''">
                                    <template v-if="chatItemInfo.is_group_chat">
                                        <div class="wrap chats_tab_name"
                                            @click="selectChatRoomForMessageMethod(chatItemInfo)"
                                            :title="chatItemInfo.name">
                                            <span class="user_prfl_status">
                                                <img :src="chatItemInfo.group_image" v-if="chatItemInfo.group_image"
                                                    alt="">
                                                <img src="@/assets/images/user_circle_avtar.png" v-else alt="" />
                                            </span>
                                            <div class="meta">
                                                <p class="name">
                                                    {{ chatItemInfo.name }}
                                                    <span class="unread_msg" v-if="chatItemInfo.unread_count">{{
                                                        chatItemInfo.unread_count }}</span>
                                                </p>
                                                <template v-if="typingUserInfoState">
                                                    <span class="typing_info_text"
                                                        v-if="chatItemInfo.chat_room == typingUserInfoState.ChatRoomId">
                                                        <template v-if="!collapseActvToggleState">{{
                                                            typingUserInfoState.typing_user.first_name }}
                                                            is</template>
                                                        typing...</span>
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="wrap chats_tab_name"
                                            @click="selectChatRoomForMessageMethod(chatItemInfo)">
                                            <span class="user_prfl_status">
                                                <img :src="chatItemInfo.user.profile.thumbnail"
                                                    v-if="chatItemInfo.user.profile.thumbnail" class="chat_user_photo">
                                                <img src="@/assets/images/user_circle_avtar.png" alt="" v-else />
                                                <template v-if="chatItemInfo.user.is_online">
                                                    <template v-if="chatItemInfo.user.current_status == 'Available'">
                                                        <i class="online-status available" title="Available"></i>
                                                    </template>
                                                    <template
                                                        v-else-if="chatItemInfo.user.current_status == 'Be Right Back'">
                                                        <i class="online-status be_right_back"
                                                            title="Be Right Back"></i>
                                                    </template>
                                                    <template
                                                        v-else-if="chatItemInfo.user.current_status == 'Lunch Away'">
                                                        <i class="online-status lunch_away" title="Lunch Away"></i>
                                                    </template>
                                                    <template v-else-if="chatItemInfo.user.current_status == 'Busy'">
                                                        <i class="online-status busy" title="Busy"></i>
                                                    </template>
                                                    <template
                                                        v-else-if="chatItemInfo.user.current_status == 'At a Meeting'">
                                                        <i class="online-status at_a_meeting" title="At a Meeting"></i>
                                                    </template>
                                                    <template v-else>
                                                        <i class="online-status online" title="Available"></i>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <i class="online-status"></i>
                                                </template>
                                            </span>
                                            <div class="meta">
                                                <p class="name" v-if="chatItemInfo.user.first_name">
                                                    {{ chatItemInfo.user.first_name }}
                                                    {{ chatItemInfo.user.last_name }}<span class="unread_msg"
                                                        v-if="chatItemInfo.unread_count">{{
                                                            chatItemInfo.unread_count }}</span>
                                                </p>
                                                <p class="name" v-else>Guest Name <span class="unread_msg"
                                                        v-if="chatItemInfo.unread_count">{{
                                                            chatItemInfo.unread_count }}</span>
                                                </p>
                                                <template v-if="typingUserInfoState">
                                                    <span class="typing_info_text"
                                                        v-if="chatItemInfo.chat_room == typingUserInfoState.ChatRoomId">
                                                        <template v-if="!collapseActvToggleState">typing</template>
                                                        ...</span>
                                                </template>
                                            </div>
                                            <div class="status_tootip_wrp"
                                                v-if="chatItemInfo.user.current_status && chatItemInfo.user.current_status != 'Available'">
                                                <span class="current_status_text">{{ chatItemInfo.user.current_status
                                                }}</span>
                                                <span class="status_time_text">Last seen
                                                    {{ getStatusTimeOfMinMethod(chatItemInfo.user.status_time) }}m
                                                    ago</span>
                                            </div>
                                        </div>
                                        <template v-if="chatItemInfo.user.is_online">
                                            <button class="btn btn-primary message_request_btn video_call_request"
                                                @click="videoCallRequestFun(chatItemInfo.user.id, chatItemInfo.chat_room)"
                                                :id="'videocallbtn' + chatItemInfo.user.id">
                                                <span class="call_txt">
                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                                        xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="38"
                                                        height="38" x="0" y="0" viewBox="0 0 452 452"
                                                        style="enable-background:new 0 0 48 48;" xml:space="preserve">
                                                        <g>
                                                            <path xmlns="http://www.w3.org/2000/svg"
                                                                d="m452 25.121094v227.820312l-121.878906-66.550781h-1.210938v-94.71875h1.210938zm0 0"
                                                                fill="#0aefea" data-original="#0aefea" />
                                                            <path xmlns="http://www.w3.org/2000/svg"
                                                                d="m328.910156 186.390625v51.03125c0 22.089844-17.910156 40-40 40h-248.910156c-22.089844 0-40-17.910156-40-40v-197.421875c0-22.089844 17.910156-40 40-40h248.910156c22.089844 0 40 17.910156 40 40zm0 0"
                                                                fill="#0aefea" data-original="#00efd1" />
                                                        </g>
                                                    </svg>
                                                </span>
                                                <span class="calling_txt">Calling</span>
                                            </button>
                                        </template>
                                        <template v-else>
                                            <button class="btn btn-primary message_request_btn video_call_request"
                                                disabled="disabled">
                                                <span class="call_txt">
                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                                        xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="38"
                                                        height="38" x="0" y="0" viewBox="0 0 452 452"
                                                        style="enable-background:new 0 0 48 48;" xml:space="preserve">
                                                        <g>
                                                            <path xmlns="http://www.w3.org/2000/svg"
                                                                d="m452 25.121094v227.820312l-121.878906-66.550781h-1.210938v-94.71875h1.210938zm0 0"
                                                                fill="#0aefea" data-original="#0aefea" />
                                                            <path xmlns="http://www.w3.org/2000/svg"
                                                                d="m328.910156 186.390625v51.03125c0 22.089844-17.910156 40-40 40h-248.910156c-22.089844 0-40-17.910156-40-40v-197.421875c0-22.089844 17.910156-40 40-40h248.910156c22.089844 0 40 17.910156 40 40zm0 0"
                                                                fill="#0aefea" data-original="#00efd1" />
                                                        </g>
                                                    </svg>
                                                </span>
                                            </button>
                                        </template>
                                    </template>
                                </li>
                            </template>
                        </ul>
                    </div>
                    <div id="vac-circle" v-else></div>
                </template>
                <!-- Connected Room List -->
                <div id="vac-circle" v-if="chatListAPILoader" class="mt-2 mb-2"></div>
            </div>
        </div>
        <user-chat-info :selectedChatRoomData="chatRoomInfo" :welcomeBlurbState="welcomeBlurbState"></user-chat-info>
        <create-group-teams v-if="createGroupPopup"></create-group-teams>
        <access-feature-of-blurb v-if="accessFeaturesOfPackageState"></access-feature-of-blurb>
        <individual-activity-tracker v-if="individualActivityTrackerState"></individual-activity-tracker>
    </div>
</template>

<script>
/*eslint-disable */

import Push from 'push.js';
import audioPlay from '@/assets/audio/piano.mp3';
import axios from 'axios';
import {
    bus
} from '@/main';
import commonSocketConnectMethod from "@/commonSocket";
import debounce from 'lodash/debounce';
import {
    mapGetters
} from 'vuex';
import moment from 'moment';
import responsiveMixin from '@/mixins/responsive';

const $ = window.jQuery = require('jquery');


// Lazy load components
const selfUserStatus = () => import('@/components/private/workspace/self-user-status');
const chatInfoSection = () => import('@/components/private/workspace/chat-info-section');
const createGroupTeams = () => import('@/components/private/workspace/create-group-teams');
const individualActivityTrackerPopup = () => import('@/components/private/workspace/individual-activity-tracker');
const accessFeaturesForBlurb = () => import('@/components/public/access-features-of-package-popup');


export default {
    name: 'chat-user-list',
    mixins: [responsiveMixin],
    components: {
        selfUserStatus,
        'user-chat-info': chatInfoSection,
        'create-group-teams': createGroupTeams,
        'individual-activity-tracker': individualActivityTrackerPopup,
        'access-feature-of-blurb': accessFeaturesForBlurb
    },
    props: [],
    data() {
        return {
            is_superuser: false,
            selfUserId: '',
            individualActivityTrackerState: false,
            connectionRequestCount: null,
            search_term: '',
            userSearchListTabs: false,
            chatSearchItemListData: null,
            chatSearchItemList: [],
            pinnedChatRoomList: [],
            fullChatRoomListData: null,
            fullChatRoomListResult: [],
            fullChatListForLoadMore: '',
            typingUserInfoState: '',
            chatRoomInfo: null,
            collapseActvToggleState: false,
            createGroupPopup: false,
            searchingContactText: 'Looking for contact',
            chatListAPILoader: false,
            accessFeaturesOfPackageState: false,
            welcomeBlurbState: false,
            menuBurgerState: false,
            isSearchEnabled: false,
            chatRoomClickable: false
        }
    },
    computed: {
        ...mapGetters([
            'acUserDetailsStateGetters',
            'getAllLeftChatListDetailsGetters',
        ]),
        selfUserInfo() {
            return this.$store.getters.acUserDetailsStateGetters.data;
        },
        fullChatData() {
            return this.$store.getters.getAllLeftChatListDetailsGetters.data;
        },
    },
    created() {
        this.initializeChatData();
    },
    mounted() {
        this.selfUserId = localStorage.getItem('LoginedUserID');
        // Typing For Selected Room Event Listener
        bus.$on('typingEventForChatBus', (data) => {
            this.typingUserInfoState = data;
            if (data.message == 'stop') {
                this.typingUserInfoState = '';
            }
        });

        // User Status Update Event Listener
        bus.$on('userUpdateStatus', (data) => {
            let targetUserId = this.fullChatRoomListResult.find(item => item.user && item.user.id === data.userID) ||
                this.pinnedChatRoomList.find(item => item.user && item.user.id === data.userID);
            if (targetUserId) {
                targetUserId.user.is_online = data.is_online;
            }
        });

        // User Self Status Event Listener
        bus.$on('userSelfStatus', (data) => {
            let targetUserId = this.fullChatRoomListResult.find(item => item.user && item.user.id === data.userID) ||
                this.pinnedChatRoomList.find(item => item.user && item.user.id === data.userID);
            if (targetUserId) {
                targetUserId.user.current_status = data.current_status;
                targetUserId.user.status_time = data.status_time;
            }
        });

        // Update Message Notification Event Listener
        bus.$on('updateMessageNotification', (data) => {
            let currentSelected = this.chatRoomInfo;
            currentSelected = currentSelected.id;
            if (data.chatRoomId == currentSelected) return;
            this.handleChatRoomNotification(data, currentSelected);
        });
        // Unread Message Count All Cleared For User Event
        bus.$on('unreadCountClearedForUserBus', (data) => {
            if (data == true) {
                let currentSelected = this.chatRoomInfo;
                let targetUserChatRoom = this.fullChatRoomListResult.find(item => item.chat_room === currentSelected.chat_room) ||
                    this.pinnedChatRoomList.find(item => item.chat_room === currentSelected.chat_room);
                if (targetUserChatRoom) {
                    targetUserChatRoom.unread_count = 0;
                }
            }
        });
        // Create Group Room Event Listener
        bus.$on('createGroupPopupBus', (data) => {
            this.createGroupPopup = data;
        });
        // Self User Chat List Live Update
        bus.$on('selfFullChatListOrdChangedBus', (data) => {
            if (data) {
                this.moveToTopIndexSelectedUserOfLiveChatMethod(data);
            }
        });

        bus.$on('collapseActvToggleStateBus', (data) => {
            this.collapseActvToggleState = data;
        })

        bus.$on('accessFeaturesOfPackageStateBus', (data) => {
            this.accessFeaturesOfPackageState = data;
        });

        bus.$on('individualActivityTrackerStateBus', (data) => {
            this.individualActivityTrackerState = data;
        });

        bus.$on('updateGroupInfoDataBus', (data) => {
            if (data) {
                this.getRoomListMethod();
            }
        })

        $('.chat_menuburger').click(function () {
            $('.chat_menuburger_wrp').toggleClass('active');
        })

        $(document).click(function (event) {
            //if you click on anything except the modal itself or the "open modal" link, close the modal
            if (!$(event.target).closest(".chat_menuburger, .chat_menu_list").length) {
                $(".chat_menuburger_wrp").removeClass("active");
            }
        });

        // Mobile View In Chat Disabled Event Listener
        bus.$on('hideChatSectionInMblBus', (data) => {
            if (data) {
                this.chatRoomInfo = null;
            }
        });
        
        bus.$on('selfUserUpdateStatus', (data) => {
         this.connectionRequestCount = data;
        });
    },
    methods: {
        mblToolbarEnabledMethod() {
            const frame = document.getElementById('frame');
            if (frame) {
                frame.classList.add('acvt_toolbar');
            }
        },
        getRoomListMethod() {
            this.chatRoomClickable = true;
            this.$store.dispatch('getAllLeftChatListDetailsFun').then((res) => {
                setTimeout(() => {
                    this.chatRoomClickable = false;
                }, 500)
            })
        },
        handleChatRoomNotification(data) {
            let targetUserChatRoom = this.fullChatRoomListResult.find(item => item.chat_room === data.chatRoomId) ||
                this.pinnedChatRoomList.find(item => item.chat_room === data.chatRoomId);

            if (targetUserChatRoom) {
                if (this.fullChatRoomListResult.includes(targetUserChatRoom)) {
                    this.moveToTopIndexSelectedUserOfLiveChatMethod(data.chatRoomId);
                }
                this.handleNotification(targetUserChatRoom, data);
            }
        },
        handleNotification(room, data) {
            const unreadByRoom = data.unreadByRoom;
            const countForSpecificId = unreadByRoom[room.chat_room];
            if (countForSpecificId > 0) {
                if (Push.Permission.has()) {
                    Push.create(data.senderName, {
                        body: data.message,
                        timeout: 4000,
                        onClick: function () {
                            window.focus();
                            this.close();
                        }
                    });
                    room.unread_count = countForSpecificId;
                } else {
                    room.unread_count = countForSpecificId;
                    this.playSound(audioPlay); // Assuming playSound is a method of 'this'
                }
            }
        },
        initializeChatData() {
            if (this.fullChatData) {
                this.pinnedChatRoomList = this.fullChatData.pinned_chat || [];
                this.fullChatRoomListResult = this.fullChatData.full_chat.results || [];
                this.fullChatListForLoadMore = this.fullChatData.full_chat.next || '';
                if (this.chatRoomClickable) return;
                this.setInitialChatRoom();
            }
        },
        setInitialChatRoom() {
            if (this.pinnedChatRoomList.length > 0) {
                if (this.isMobile) return;
                this.chatRoomInfo = this.pinnedChatRoomList[0];
                this.welcomeBlurbState = false;
            } else if (this.fullChatRoomListResult.length > 0) {
                if (this.isMobile) return;
                this.chatRoomInfo = this.fullChatRoomListResult[0];
                this.welcomeBlurbState = false;
            } else {
                this.welcomeBlurbState = true;
            }
        },
        // User Searchbar Styling for Code Here
        handleSearchbarFocus() {
            this.isSearchEnabled = true;
        },
        menuBurgerClosedMethod() {
            if (this.menuBurgerState) {
                this.menuBurgerState = false;
            }
        },
        menuBurgerMethod() {
            this.menuBurgerState = true;
        },
        accessFeaturesOfPackagemethod() {
            this.accessFeaturesOfPackageState = true;
            document.body.classList.add('body_right_scroll_remove');
        },
        // Chat user List Pagination Of The Event Listener
        handleScroll() {
            const chatListEl = this.$refs.chatList;
            let yScrollHeight = chatListEl.scrollHeight;
            let scrollTopEvt = chatListEl.scrollTop + chatListEl.clientHeight + 1;
            if (scrollTopEvt > yScrollHeight) {
                if (this.fullChatListForLoadMore) {
                    if (!this.chatListAPILoader) {
                        this.chatListAPILoader = true;
                        axios.get(this.fullChatListForLoadMore).then((response) => {
                            this.fullChatRoomListResult = [].concat(this.fullChatRoomListResult, response.data.data.full_chat.results);
                            this.fullChatListForLoadMore = response.data.data.full_chat.next;
                            this.chatListAPILoader = false;
                        })
                    }
                }
            }
        },
        /*
         * This Will Video Call Request Function
        */
        videoCallRequestFun(callerId, roomId) {
            $('.video_call_request').removeClass('call_actv');
            $('#videocallbtn' + callerId).addClass('call_actv');
            let callerFullName = this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name;
            commonSocketConnectMethod.emit({
                callerName: callerFullName,
                type: "videoCalling",
                callerID: this.selfUserId,
                targetId: callerId,
                roomId: roomId
            });
            commonSocketConnectMethod.$on('videoCallAcceptedNotification', this.getAnswerOfVideoCall);
            commonSocketConnectMethod.$on('videoCallDeclinedNotification', this.getDeclinedOfVideoCall);
            commonSocketConnectMethod.$on('videoCallAlertPopupClosed', this.notrecievedCall);
            commonSocketConnectMethod.$on('autoMissedCallEvent', this.autoMissedCall);
        },
        getAnswerOfVideoCall(getAnswerData) {
            if (this.selfUserId == getAnswerData.targetId) {
                this.$router.push('/video/call/one-to-one-peer/#' + getAnswerData.roomId);
            }
        },
        getDeclinedOfVideoCall(declinedData) {
            $('#videocallbtn' + declinedData.callerID).removeClass('call_actv');
        },
        notrecievedCall(notrecievedData) {
            $('#videocallbtn' + notrecievedData.targetId).removeClass('call_actv');
        },
        autoMissedCall(mCallData) {
            $('#videocallbtn' + mCallData.targetId).removeClass('call_actv');
        },
        /*
         * this will check the new message notification
         */
        playSound(sound) {
            if (sound) {
                var audio = new Audio(sound);
                audio.play();
            }
        },
        /*
         * Get Minutes From Status Time Methods
         */
        getStatusTimeOfMinMethod(sc) {
            var cth = moment().format('HH');
            var ctm = moment().format('mm:ss');
            var sth = moment(sc).format('HH');
            var stm = moment(sc).format('mm:ss');
            var cft = cth * parseInt(60) + parseInt(ctm);
            var sft = sth * parseInt(60) + parseInt(stm);
            var nt = cft - sft;
            return nt;
        },
        createGroupPopupEnabledFun() {
            this.createGroupPopup = true;
        },
        individualActivityTrackerOpenMethod() {
            this.individualActivityTrackerState = true;
            document.body.classList.add('body_right_scroll_remove');
        },
        /*
         * This Will User Search For New Chat Api
         */
        onChangeSearchUser() {
            if (this.search_term.length >= 3) {
                this.userSearchListTabs = true;
                this.$store.dispatch('getUserForChatAction', {
                    search_term: this.search_term
                }).then((response) => {
                    this.chatSearchItemListData = response.data;
                    this.chatSearchItemList = this.chatSearchItemListData.results;
                })
            } else {
                this.userSearchListTabs = false;
                this.chatSearchItemList = [];
                this.chatSearchItemListData = null;
            }
        },

        debouncedSearch: debounce(function () {
            this.onChangeSearchUser();
        }, 200),

        /*
         * This Will Close User Searchbar
         */
        searchBarForChatClosedFun() {
            this.userSearchListTabs = false;
            this.chatSearchItemList = [];
            this.search_term = '';
            this.chatSearchItemListData = null;
            this.isSearchEnabled = false;
        },
        outsideClickOfSearchFieldMethod() {
            if (this.search_term.length > 0) return;
            this.userSearchListTabs = false;
            this.isSearchEnabled = false;
            this.charSearchOfUsersList = [];
            this.search_term = '';
        },
        selectChatRoomForMessageMethod(roomInfo) {
            if (!roomInfo) return;
            if ((this.chatRoomInfo && this.chatRoomInfo.chat_room) == roomInfo.chat_room) return;
            this.chatRoomInfo = roomInfo;
            if (!this.isMobile) return;
            this.showMenuBarOnMblMethod();
        },
        searchingChatRoomForMessageMethod(roomInfo) {
            if (!roomInfo) return;
            this.chatRoomInfo = roomInfo;
        },

        showMenuBarOnMblMethod() {
            // Get the element with id 'sidepanel'
            const sidepanel = document.getElementById('sidepanel');
            if (sidepanel) {
                sidepanel.classList.add('d-none');
            }

            // Get the element with id 'chatContentWrp'
            const chatContentWrp = document.getElementById('chatContentWrp');
            if (chatContentWrp) {
                chatContentWrp.classList.add('d-block');
            }
        },

        /*
         * This Will Move On Top Selected User From List
         */
        moveToTopIndexSelectedUserOfLiveChatMethod(itemId) {
            const itemIndex = this.fullChatRoomListResult.findIndex(item => item.chat_room === itemId);
            if (itemIndex) {
                this.fullChatRoomListResult.unshift(this.fullChatRoomListResult.splice(itemIndex, 1)[0])
            }
        },
    },
    watch: {
        fullChatData: {
            handler() {
                this.initializeChatData();
            },
            // deep: true,
        },
    }
}
</script>

<style lang="scss" scoped>
.chat_workspace_wrp {
    height: 100%;
    width: 68%;
    float: left;
    transition: all ease-in-out 0.5s;
    -webkit-transition: all ease-in-out 0.5s;
    -moz-transition: all ease-in-out 0.5s;

    @media only screen and (max-width:769px) {
        width: 100%;
    }

    #sidepanel {
        width: 45%;
        float: left;
        height: 100%;
        background: #111111;
        color: #f5f5f5;
        overflow: hidden;
        position: relative;
        transition: all ease-in-out 0.5s;
        -webkit-transition: all ease-in-out 0.5s;
        -moz-transition: all ease-in-out 0.5s;

        @media only screen and (max-width:769px) {
            width: 100%;
        }
    }

    .content {
        width: 55%;
        transition: all ease-in-out 0.5s;
        -webkit-transition: all ease-in-out 0.5s;
        -moz-transition: all ease-in-out 0.5s;

        @media only screen and (max-width:769px) {
            width: 100%;
            display: none;
        }
    }
}

#sidepanel {
    #search {
        font-weight: 300;
        padding: 10px;

        label {
            position: absolute;
            margin: 8px 0 0 20px;
        }

        input {
            font-family: "proxima-nova", "Source Sans Pro", sans-serif;
            padding: 10px 10px 10px 46px;
            width: 100%;
            border: none;
            background: #111111;
            color: #f5f5f5;
            font-size: 14px;

            &:focus {
                outline: none;
                background: #232323;
            }

            &::-webkit-input-placeholder {
                color: #f5f5f5;
            }

            &::-moz-placeholder {
                color: #f5f5f5;
            }

            &:-ms-input-placeholder {
                color: #f5f5f5;
            }

            &:-moz-placeholder {
                color: #f5f5f5;
            }
        }
    }

    #contacts_list {
        ul {
            margin: 0;

            li.contact {
                position: relative;
                padding: 10px;
                border-right: 5px solid transparent;

                &:hover {
                    background: #181c1f;
                }

                &.active {
                    background: #1d2226;

                    span.contact-status {
                        border: 2px solid #111111 !important;
                    }
                }

                .wrap {
                    width: 100%;
                    position: relative;
                    clear: both;
                    display: flex;
                    align-items: center;
                    padding-right: 50px;

                    &.chats_tab_name {
                        cursor: pointer;
                    }

                    .user_prfl_status {
                        width: 44px;
                        border-radius: 50%;
                        position: relative;
                        margin-right: 10px;
                        height: 44px;
                        flex: 0 0 44px;

                        img {
                            width: 100%;
                            border-radius: 50%;
                            height: 100%;
                            object-fit: cover;
                            object-position: top center;
                        }
                    }

                    .unread_msg {
                        margin-left: 5px;
                        font-size: 11px;
                        vertical-align: middle;
                        display: inline-block;
                        background: #87cefa;
                        border-radius: 50%;
                        color: #000000;
                        width: 20px;
                        height: 20px;
                        line-height: 20px;
                        text-align: center;
                        font-weight: 600;
                    }

                    .meta {
                        .name {
                            margin: 0px;
                            max-width: 100%;
                            font-size: 18px;
                        }

                        .preview {
                            margin: 5px 0 0 0;
                            padding: 0 0 1px;
                            font-weight: 400;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            -moz-transition: 1s all ease;
                            -o-transition: 1s all ease;
                            -webkit-transition: 1s all ease;
                            transition: 1s all ease;

                            span {
                                position: initial;
                                border-radius: initial;
                                background: none;
                                border: none;
                                padding: 0 2px 0 0;
                                margin: 0 0 0 1px;
                                opacity: .5;
                            }
                        }
                    }

                    &.chats_tab_name .meta .name {
                        max-width: 260px;
                    }
                }
            }

        }

        &.expanded {
            height: calc(100% - 334px);
        }
    }

    .chat_menuburger_wrp {
        position: relative;

        .chat_menuburger {
            display: inline-block;
            width: 10px;
            height: 21px;
            text-align: center;
            position: relative;
            vertical-align: middle;
            margin-right: 0px;
            cursor: pointer;

            &>span {
                display: inline-block;
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background: #fff;
                position: absolute;
                left: 0;
                right: 0;
                margin: 0 auto;

                &:first-child {
                    top: 0;
                }

                &:nth-child(2) {
                    top: 8px;
                }

                &:nth-child(3) {
                    top: 16px;
                }
            }
        }

        .chat_menu_list {
            margin: 0;
            background: #000;
            position: absolute;
            right: 13px;
            top: 35px;
            z-index: 100;
            width: 115px;
            text-align: center;
            padding: 5px 0;
            border-radius: 2px;
            display: none;
            border: 1px solid #ffc107;

            &:before {
                width: 0;
                border-bottom: 7px solid #ffc107;
                border-right: 7px solid transparent;
                border-left: 7px solid transparent;
                content: "";
                position: absolute;
                top: -8px;
                right: 0;
            }

            li {
                padding: 3px 10px;

                a {
                    color: #ffc107;
                    font-size: 13px;
                    font-family: "proxima-nova", "Source Sans Pro", sans-serif;
                    text-decoration: none;
                    font-weight: 500;
                    letter-spacing: 0.3px;

                    &:hover {
                        color: #ffffff;
                    }
                }
            }
        }

        &.active .chat_menu_list {
            display: block;
        }

        .btn-default {
            padding: 7px 15px;
            font-size: 15px;
            border-radius: 70px;
            background: rgba(255, 255, 255, 0.12);
            color: #ffd400;
            border: none;
            margin-right: 5px;
            text-transform: capitalize;
            font-weight: 400;
            letter-spacing: .03em;
            line-height: 1;
            transition: all ease 0.5s;
            -webkit-transition: all ease 0.5s;
            -moz-transition: all ease 0.5s;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            box-shadow: none !important;

            &:hover {
                background: #87cefa;
                color: #22292f;
            }
        }
    }

    .btn {
        outline: none !important;
        box-shadow: none !important;
    }

    .btn-primary {
        &.team_group_create_btn {
            text-align: center;
            font-family: AceSansDemo;
            font-size: 17px;
            display: inline-block;
            padding: 7px 10px;
            letter-spacing: 1px;
            border-radius: 3px;
            min-width: 80px;
            border: none;
            line-height: 1;
            outline: none;
            -webkit-box-shadow: none;
            box-shadow: none;
            border: 2px solid #ff4338;
            color: #fff;
            background: none;
            font-weight: 700;

            &:hover {
                background: #ffd400;
                color: #000;
                border-color: #ffd400;
            }
        }

        &.message_request_btn {
            font-size: 16px;
            background-color: rgba(31, 31, 31, 0.5);
            border: 1px solid rgba(174, 182, 184, 0.1);
            color: #fff;
            position: absolute;
            right: 50px;
            top: 50%;
            border-radius: 3px;
            padding: 5px;
            letter-spacing: 0px;
            line-height: 1;
            font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;
            min-width: 36px;
            height: 34px;
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            overflow: hidden;

            .calling_txt {
                display: none;
            }

            &.call_actv {
                background: #87cefa !important;
                color: #000 !important;

                svg path,
                svg path {
                    fill: #000000;
                }
            }

            &.call_actv {
                .calling_txt {
                    display: inline-block;
                }
            }

            &.call_actv {
                .call_txt {
                    display: none;
                }
            }

            &.video_call_request {
                right: 5px;
            }

            &::before {
                content: "";
                position: absolute;
                top: 0;
                width: 100%;
                height: 100%;
                background: linear-gradient(120deg,
                        transparent,
                        rgba(255, 255, 255, 0.2),
                        transparent);
                left: -100%;
                transition: all 0.65s ease-in-out;
            }

            &:hover {
                box-shadow: 1px 1px 25px 10px rgba(255, 255, 255, 0.5) !important;

                &::before {
                    left: 100%;
                }
            }
        }
    }

    .user_search_for_new_chat {
        padding: 10px;
        background: none;
        border: 1px solid transparent;
        border-bottom-color: #171b1f;

        .search_for_new_chat_inner {
            position: relative;
            background: none;
            border-radius: 80px;
            padding: 0;
            border: 3px solid rgba(255, 255, 255, 0.15);

            .back {
                display: none;
                position: absolute;
                left: 10px;
                top: 50%;
                transform: translateY(-50%);
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                cursor: pointer;

                &.actv_action svg path {
                    fill: #ffd400;
                }
            }

            .search {
                position: absolute;
                left: 10px;
                top: 50%;
                transform: translateY(-50%);
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
            }

            .x-alt {
                position: absolute;
                right: 15px;
                top: 45%;
                transform: translateY(-50%);
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                display: none;
                cursor: pointer;

                svg:hover path {
                    fill: #87cefa;
                }

                &.search_disabled_btn {
                    display: block;
                }
            }

            .form-control {
                background: none;
                border: none;
                color: #ffffff;
                padding: 8px 45px;
                height: auto;
                font-size: 16px;
                outline: none;
                box-shadow: none;
                color: #ffd400;

                &::placeholder,
                &::-webkit-input-placeholder,
                &::-moz-placeholder {
                    color: rgba(255, 255, 255, 0.6);
                }

                &:focus::-webkit-input-placeholder {
                    font-size: 0;
                }

                &:focus::-moz-placeholder {
                    font-size: 0;
                }

                &:focus+.back path,
                &.active+.back path {
                    fill: #ffd400;
                }
            }
        }

        &.search_enabled,
        &.searching_enabled {
            .search_for_new_chat_inner {
                border: 3px solid #ffd400;

                .search {
                    display: none;
                }

                .back {
                    display: block;
                }
            }
        }
    }

    .video_calling_btn_wrp {
        &.disabled_btn_global {
            opacity: 1 !important;

            .call_txt {
                opacity: 0.65;
            }

            &:hover {
                background: rgba(135, 206, 250, 0.65) !important;
            }
        }

        &:hover .user_offline_tooltip {
            display: block;
        }
    }

    .video_call_request:disabled {
        cursor: not-allowed;
        opacity: 0.4;
    }

    .badge-dark.connectionRequestCountWrp {
        padding: 2px 4px;
        background-color: #cf231e;
        -webkit-animation: blink 1.5s linear infinite;
        -moz-animation: blink 1.5s linear infinite;
        -ms-animation: blink 1.5s linear infinite;
        -o-animation: blink 1.5s linear infinite;
        animation: blink 1.5s linear infinite;
    }

    @keyframes blink {
        0% {
            opacity: 0;
        }

        50% {
            opacity: .5;
        }

        100% {
            opacity: 1;
        }
    }

    @-webkit-keyframes blink {
        0% {
            opacity: 0;
        }

        50% {
            opacity: .5;
        }

        100% {
            opacity: 1;
        }
    }

    @-moz-keyframes blink {
        0% {
            opacity: 0;
        }

        50% {
            opacity: .5;
        }

        100% {
            opacity: 1;
        }
    }

    @-o-keyframes blink {
        0% {
            opacity: 0;
        }

        50% {
            opacity: .5;
        }

        100% {
            opacity: 1;
        }
    }

    .chat_menuburger_wrp .btn-default:hover .badge-dark.connectionRequestCountWrp {
        background: #22292f;
        -webkit-animation-play-state: paused;
        animation-play-state: paused;
        opacity: 1 !important;
    }

    .typing_info_text {
        font-size: 14px;
        color: #00de09;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        display: block;
    }

    .user_list_for_chat {
        ul {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;

            li.chat_user_listed {
                width: 100%;
                -webkit-box-flex: 0;
                -ms-flex: 0 0 100%;
                flex: 0 0 100%;
                -ms-flex-order: 100;
                order: 100;
                transition: order cubic-bezier(0.4, 0, 1, 1) 0.5s;
                -webkit-transition: order cubic-bezier(0.4, 0, 1, 1) 0.5s;
                -moz-transition: order cubic-bezier(0.4, 0, 1, 1) 0.5s;

                &:hover {
                    .status_tootip_wrp {
                        opacity: 1;
                        visibility: visible;
                    }
                }
            }
        }
    }

    .collsaped_chatlist_menu {
        text-align: right;
        padding: 10px 15px;
        display: none !important;

        .fa-bars {
            font-size: 22px;
            color: #9b9b9b;
            cursor: pointer;
        }

        .active .fa-bars {
            color: #ffc107;
        }
    }

    .contact {
        .wrap {
            .meta {
                .name {
                    opacity: 1;
                    overflow: visible;
                    white-space: normal;
                    visibility: visible;
                    width: 100%;

                    &.active {
                        white-space: nowrap;
                        opacity: 0;
                    }
                }
            }
        }
    }

    #search.active .chat_menuburger_wrp {
        display: none
    }

    .status_tootip_wrp {
        background: #ffdee3;
        color: #000;
        position: absolute;
        right: 45px;
        top: 0;
        z-index: 1000;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        padding: 5px 10px;
        opacity: 0;
        visibility: hidden;
        transition: all ease-in-out 0.5s;
        -webkit-transition: all ease-in-out 0.5s;
        -moz-transition: all ease-in-out 0.5s;

        span {
            display: block;
            line-height: 1;

            &.current_status_text {
                font-size: 14px;
                margin-bottom: 3px;
            }

            &.status_time_text {
                font-size: 13px;
                color: #5c5c5c;
            }
        }
    }

    .user_prfl_status {
        .online-status {
            position: absolute;
            left: 32px;
            bottom: 4px;
            border: 1px solid #9E9E9E;
            border-radius: 50%;
            width: 12px;
            height: 12px;
            background: #9E9E9E;

            &.available {
                background-color: #38b124;
                border-color: #38b124;
            }

            &.be_right_back {
                background-color: #f3d32d;
                border-color: #f3d32d;
            }

            &.lunch_away {
                background-color: #1483E5;
                border-color: #1483E5;
            }

            &.busy {
                background-color: #ee0809;
                border-color: #ee0809;
            }

            &.at_a_meeting {
                background-color: #f66c11;
                border-color: #f66c11;
            }

            &.online {
                background-color: #4CAF50;
                border-color: #4CAF50;
            }

            &.away {
                background-color: #f1c40f;
                border-color: #f1c40f;
            }

            &.busy {
                background-color: #F44336;
                border-color: #F44336;
            }
        }
    }
}

#sidepanel:not(.collapsed_chat_list) {
    #contacts_list {
        height: calc(100% - 120px);
        overflow-y: auto;
        overflow-x: hidden;

        &::-webkit-scrollbar {
            width: 4px;
            background: #00000016;
        }

        &::-moz-scrollbar {
            width: 4px;
            background: #00000016;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #232323;
        }

        &::-moz-scrollbar-thumb {
            background-color: #232323;
        }
    }
}

@-webkit-keyframes vac-spin {
    from {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    to {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}

@keyframes vac-spin {
    from {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    to {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}

#sidepanel #vac-circle {
    margin: auto;
    height: 28px;
    width: 28px;
    border: 3px rgba(0, 0, 0, 0.25) solid;
    border-top: 3px #c0bebe solid;
    border-right: 3px #c0bebe solid;
    border-bottom: 3px #c0bebe solid;
    border-radius: 50%;
    -webkit-animation: vac-spin 1s infinite linear;
    -moz-animation: vac-spin 1s infinite linear;
    animation: vac-spin 1s infinite linear;
    margin-top: 25vh;
}

#frame.collapsed_chat_list {
    #sidepanel {
        width: 145px;

        #contacts_list {
            height: 100%;
        }
    }

    .chat_workspace_wrp {
        width: 50%;

        .content {
            width: calc(100% - 147px);
        }
    }

    #search,
    .user_search_for_new_chat {
        display: none !important;
    }

    .collsaped_chatlist_menu {
        display: block !important;

        .btn-primary {
            min-width: 65px;
            padding: 5px;
            font-size: 16px;
        }
    }

    .chat_menu_list {
        top: 28px !important;
    }
}

@media only screen and (min-width:768px) and (max-width:1310px) {
    #sidepanel .chat_menuburger_wrp .btn-default {
        font-size: 13px;
        padding: 6px 8px;
    }

    #sidepanel .btn-primary.team_group_create_btn {
        font-size: 13px;
        padding: 6px;
        min-width: 70px;
    }

    #sidepanel #contacts_list ul li.contact .wrap .meta .name {
        font-size: 16px;
    }

    #sidepanel .user_search_for_new_chat .search_for_new_chat_inner .form-control {
        font-size: 14px;
    }
}
</style>